module.exports = __webpack_public_path__ + "img/img_22.2cd81e1c.png";